import { Component } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { OrdersService } from 'src/app/services/orders.service';

@Component({
  standalone: false,
  selector: 'app-message-popup',
  templateUrl: './message-popup.component.html',
  styleUrls: ['./message-popup.component.scss'],
})
export class MessagePopupComponent {
  title;
  text;
  buttonText;
  buttonFunction;

  constructor(
    public modalController: ModalController,
    private ordersService: OrdersService,
    private alertController: AlertController
  ) {}

  closeModal() {
    this.modalController.dismiss();
  }

  buttonClicked() {
    if (this.buttonFunction) {
      this.buttonFunction();
    }
    this.closeModal();
  }
}
